module.exports = __webpack_public_path__ + "static/media/29DUNON4.53dbe56c.jpg";